import { setAsyncUrl, fetchRequest } from '@tk/utilities/tk.fetch';
import TKArticleList from '@tk/components/tk.article.list';

enum ArticleDataType {
    PRICE = 'price',
    STOCK = 'stock',
}

export default class DIWArticleList extends TKArticleList {
    constructor() {
        super();
    }

    handleStock() {
        const elements = this.querySelectorAll('[data-tk-stock-wrapper]');
        const filteredList = [...elements];
        if (filteredList.length !== this.stocks.length) return;
        const url = filteredList.at(0)?.getAttribute('data-tk-async-url') || setAsyncUrl(true);
        this.isCustomStockURL = url !== setAsyncUrl(true);
        fetchRequest({
            requestURL: url,
            resolveHandler: this.refreshStockData.bind(this),
            payload: this.getPreparedData(ArticleDataType.STOCK),
        });
    }
}
